import { useDroppable } from '@dnd-kit/core';
import { cn } from '@/lib/utils';

interface DroppableTaskColumnProps {
  id: string;
  children: React.ReactNode;
}

export function DroppableTaskColumn({ id, children }: DroppableTaskColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div 
      ref={setNodeRef}
      className={cn(
        "space-y-2 min-h-[200px] bg-muted/30 rounded-lg p-2 transition-all duration-200",
        isOver && "bg-primary/10 ring-2 ring-primary"
      )}
    >
      {children}
    </div>
  );
}
